// extracted by mini-css-extract-plugin
export default {"screenMd":"62rem","endeavour":"#0057b7","greyLighter":"#6f6f6f"};